/** Tras rechazar el aviso de instalación, silencio durante un mes. */
const DISMISS_QUIET_DAYS = 30;

/** true si el rechazo guardado (ms en texto) es más reciente que el periodo de silencio. */
export function isWithinQuietPeriod(
  dismissedAtRaw: string | null,
  now: number = Date.now(),
  quietDays: number = DISMISS_QUIET_DAYS
): boolean {
  if (!dismissedAtRaw) return false;
  const at = Number(dismissedAtRaw);
  if (!Number.isFinite(at)) return false;
  return now - at < quietDays * 24 * 60 * 60 * 1000;
}

/**
 * Safari dentro de otra aplicación (Instagram, Gmail, etc.) o con otro motor no
 * tiene el botón de compartir con "Agregar a pantalla de inicio", así que
 * explicarlo ahí sólo confunde.
 */
export function isIosStandaloneCapableUserAgent(userAgent: string): boolean {
  const inAppBrowser = /FBAN|FBAV|Instagram|Line|Twitter|LinkedIn|MicroMessenger/i.test(userAgent);
  const otherEngine = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);
  return !inAppBrowser && !otherEngine;
}

/** Siguiente número de visitas a partir del contador guardado (texto o null). */
export function nextVisitCount(storedRaw: string | null): number {
  const current = Number(storedRaw ?? "0");
  return Number.isFinite(current) ? current + 1 : 1;
}
